import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import moment from "moment";
import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/Save";
import AsyncDropdown from "../../utils/asyncDropdown/AsyncDropdown";
import { useSelector } from "react-redux";
import { getActivepanels } from "../managePanel/managePanel.api";
import { updateCampaign, createCampaign } from "../campaign/campaign.api";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";

const ConfUser = (props) => {
  const {
    open,
    hadnleCloseModal,
    type,
    setSuccess,
    setAlert,
    setError,
    setEditId,
    editId,
    selectedItem,
    roleSelected,
    miniSurveyCode,
    activePanels,
  } = props;

  // states
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [selectedPanels, setSelectedPanels] = useState([]);
  const [panels, setPanels] = useState([]);
  const adminId = useSelector((state) => state.auth.userData?.tenantId);
  const [filterData, setFilterData] = useState({
    launchDate: moment().subtract("months").format("YYYY-MM-DD"),
  });

  const [userData, setUserData] = useState({
    campaignName: "",
    points: "",
    campaignUrl: "",
    launchDate: "",
    duration: "00:00:00", // default duration value
    description:""
  });

  const [durationError, setDurationError] = useState(false);

  useEffect(() => {
    getActivepanels(adminId).then((res) => {
      if (res?.status === 200) {
        const panels = res.data.data;
        setSelectedPanels(panels[0]);
      }
    });
    return () => {
      setSelectedPanels({});
    };
  }, [adminId]);

  useEffect(() => {
    if (selectedItem && Object.keys(selectedItem).length > 0) {
      setUserData({
        campaignName: selectedItem.campaignName || "",
        points: selectedItem.points || "",
        campaignUrl: selectedItem.campaignUrl || "",
        launchDate: setFilterData({
          launchDate:
            moment(selectedItem.launchDate).format("YYYY-MM-DD") || "",
        }),
        duration: formatDurationForPicker(selectedItem.duration) || "00:00:00", // Ensure default value for duration
        description: selectedItem.description
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const isTimePicker = typeof e === "string"; // TimePicker sends a string directly
    let name, value;

    if (isTimePicker) {
      name = "duration"; // Since TimePicker does not provide `name`
      value = e || "00:00:00"; // Default to "00:00:00" if empty
    } else {
      name = e?.target?.name;
      value = e?.target?.value;
    }
    if (name === "points") {
      // Allow empty string (for backspace) or positive integers
      if (value !== "" && !/^\d+$/.test(value)) {
        return;
      }
    }
    if (name === "launchDate") {
      setFilterData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "duration" && value !== "00:00:00") {
      setDurationError(false); // Reset error if duration is not "00:00:00"
    }
  };

  const handlePanelDropDownChange = (value, dropDownName) => {
    if (dropDownName === "PANEL") {
      setSelectedPanels(value);
    }
  };
  const formatDurationForPicker = (duration) => {
    if (!duration) return "00:00:00"; // Default if duration is not provided

    const parts = duration.split(":");

    if (parts.length === 2) {
      // If API returns "MM:SS", prepend "00:"
      return `00:${parts[0]}:${parts[1]}`;
    }

    return duration; // Keep "HH:MM:SS" as it is
  };

  const formatDurationForAPI = (duration) => {
    if (!duration) return "";

    const parts = duration.split(":");

    if (parts.length === 3 && parts[0] === "00") {
      // Remove "00:" if hours are 00
      return `${parts[1]}:${parts[2]}`;
    }

    return duration; // Keep full format if hours exist
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userData.duration === "00:00:00") {
      setDurationError(true); // Set error if duration is "00:00:00"
      return;
    }
    let panelIds = [];
    if (selectedPanels && selectedPanels.length > 0) {
      selectedPanels.map((item) => panelIds.push(item.panelId));
    }
    setLoading(true);
    let callMethod;
    if (type === "ADD") {
      let newData = {
        campaignName: userData.campaignName,
        points: userData.points,
        campaignUrl: userData.campaignUrl,
        launchDate: filterData.launchDate,
        duration: formatDurationForAPI(userData.duration),
        description: userData.description
      };
      callMethod = createCampaign(newData);
    } else {
      let data = {
        campaignName: userData.campaignName,
        points: userData.points,
        campaignUrl: userData.campaignUrl,
        launchDate: filterData.launchDate,
        duration: formatDurationForAPI(userData.duration),
        description: userData.description
      };
      callMethod = updateCampaign(selectedItem.campaignId, data);
    }
    callMethod
      .then((res) => {
        if (!res.data.success) {
          if (res.data.message === "Campaign already exist") {
            setAlert("Campaign already exist");
            setLoading(false);
          }
          return;
        }
        if (res?.status === 201 || res?.status === 200) {
          setSuccess();
          setLoading(false);
          setUserData({
            campaignName: "",
            points: "",
            campaignUrl: "",
            launchDate: "",
            duration: "00:00:00", // Reset duration after success
          });
          hadnleCloseModal();
        } else {
          setLoading(false);
          setError("Something went wrong");
        }
      })
      .catch((err) => {
        setLoading(false);
        setError("Something went wrong");
      });
  };

  return (
    <Dialog fullWidth={"true"} open={open} onClose={hadnleCloseModal}>
      <form onSubmit={handleSubmit}>
        <span className={"closeButton"} onClick={hadnleCloseModal}>
          <i className="bi bi-x"></i>
        </span>
        <DialogTitle>
          {type === "ADD"
            ? "Add Campaign - Opinion-Edge"
            : "Edit Campaign - Opinion-Edge"}
        </DialogTitle>
        <DialogContent style={{ paddingBottom: 0 }}>
          <Box padding={2}>
            <Stack direction={"column"} spacing={2}>
              {type === "ADD" && (
                <Stack
                  direction={"row"}
                  spacing={2}
                  justifyContent={"space-between"}
                >
                  <AsyncDropdown
                    label={"Panel Name"}
                    disabled={props.disableDropDowsn}
                    value={selectedPanels}
                    handleChange={(value) =>
                      handlePanelDropDownChange(value, "PANEL")
                    }
                    name="panelId"
                    options={activePanels}
                    objKey={"panelName"}
                    stylized
                  />
                </Stack>
              )}
              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"space-between"}
              >
                <TextField
                  onChange={handleInputChange}
                  fullWidth
                  type={"text"}
                  label={"Campaign Name"}
                  name="campaignName"
                  required
                  value={userData.campaignName}
                />
              </Stack>

              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"space-between"}
              >
                <TextField
                  onChange={handleInputChange}
                  fullWidth
                  type={"text"}
                  label={"Description"}
                  name="description"
                  required
                  value={userData.description}
                />
              </Stack>

              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"space-between"}
              >
                <TextField
                  onChange={handleInputChange}
                  fullWidth
                  type={"number"}
                  label={"Points"}
                  name="points"
                  required
                  value={userData.points}
                  onKeyDown={(e) => {
                    if (e.key === "." || e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                />
                <TextField
                  fullWidth
                  name={"launchDate"}
                  value={filterData.launchDate}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Launch Date"}
                  type={"date"}
                  onChange={handleInputChange}
                />
              </Stack>
              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"space-between"}
              >
                <TextField
                  onChange={handleInputChange}
                  fullWidth
                  type={"text"}
                  label={"Link"}
                  name="campaignUrl"
                  required
                  value={userData.campaignUrl}
                />
              </Stack>
              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"space-between"}
              >
                <Box sx={{ width: "48%" }}>
                  <InputLabel htmlFor="duration-input" sx={{ mb: 1 }}>
                    Duration (HH:mm:ss)
                  </InputLabel>
                  <TimePicker
                    id="duration-input"
                    onChange={handleInputChange}
                    value={userData.duration || "00:00:00"}
                    format="HH:mm:ss"
                    disableClock={true}
                    clearIcon={null}
                    maxDetail="second"
                    className="custom-time-picker"
                  />
                  {durationError && (
                    <span style={{ color: "red", fontSize:"14px" }}>
                      Duration cannot be 00:00:00
                    </span>
                  )}
                </Box>
              </Stack>
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 24px 20px" }}>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<SaveIcon />}
            variant="contained"
            type={"submit"}
          >
            {type === "ADD" ? "Save" : "Update"}
          </LoadingButton>
          <Button variant="outlined" onClick={hadnleCloseModal}>
            Cancel
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ConfUser;
